import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}
export function GoogleTagLoader() {
  useEffect(() => {
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17947977509';
    document.head.appendChild(script);
    // Initialize dataLayer and gtag
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17947977509');

      window.gtag_report_conversion = function(url) {
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.location = url;
          }
        };
        gtag('event', 'conversion', {
          'send_to': 'AW-17947977509/eaWRCLyBgfcbEKXOoe5C',
          'value': 1.0,
          'currency': 'USD',
          'event_callback': callback
        });
        return false;
      };
    `;
    document.head.appendChild(inlineScript);
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (document.head.contains(inlineScript)) {
        document.head.removeChild(inlineScript);
      }
    };
  }, []);
  return null;
}
export function trackCalendlyConversion() {
  if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    window.gtag_report_conversion();
  }
}